<template>
<span class="profile-badge">
  <img class="avatar" v-if="avatar_data.avatar_thumb" v-b-tooltip.hover :disabled="tooltipDisabled" :src="avatar_data.avatar_thumb" :title="avatar_data.display_name">
  <span class="no-avatar" v-if="!avatar_data.avatar_thumb && !defaultAvatar" v-b-tooltip.hover :disabled="tooltipDisabled" :title="avatar_data.display_name">{{ avatar_data.initials }}</span>
  <span v-if="defaultAvatar"><font-awesome-icon icon="fa-solid fa-user" /></span>
</span>
</template>
<script>
    import AvatarService from "@/store/services/avatar.service.js";

    export default {
        name: "Avatar",
        props: {
            userId: Number,
            companyLogo: {
                type: Object,
                default: () => {}
            },
            tooltipDisabled: {
                type: Boolean,
                default: false
            },
            defaultAvatar: {
                type: Boolean,
                default: false
            },
        },
        components: {},
        data () {
            return {
                avatar_data: {}
            }
        },
        created () {
            if (this.userId) {
                AvatarService.retrieve(this.userId).then((response) => {
                    this.avatar_data = response.data;
                })
            } else if (this.companyLogo) {
                this.avatar_data = {
                    avatar_thumb: this.companyLogo.logo_thumbnail,
                    display_name: this.companyLogo.name,
                    initials: this.companyLogo.name.substring(0, 1)
                }
            }
        },
        methods: {}
    };
</script>
<style scoped>
    .avatar {
        margin-top: 3px;
        width: 36px;
        height: 36px;
        min-width: 36px;
        min-height: 36px;
        display: inline-block;
        background: #ccc;
        color: #222;
        margin-right: 5px;
        border-radius: 20px;
        float: left;
    }
</style>